/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { formatDependencies } from './dependenciesFormat.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createBin } from '../../factoriesAny.js';
export var binDependencies = {
  formatDependencies,
  typedDependencies,
  createBin
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesBin.generated.js
// module id = J7nY
// module chunks = 3